import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import CopyButton from 'jitsi/base/buttons/CopyButton.web';
import { getDecodedURI } from 'jitsi/base/util/uri';
const useStyles = makeStyles()((theme) => {
    return {
        container: {
            marginTop: theme.spacing(4),
        },
        label: {
            marginBottom: theme.spacing(2),
        },
        iconRow: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        iconContainer: {
            display: 'block',
            padding: theme.spacing(2),
            cursor: 'pointer',
        },
        copyButton: {
            width: 'fit-content !important',
        },
        textAreaContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
        },
        embedMeetingText: {
            padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
            marginBottom: theme.spacing(2),
            color: theme.palette.iisightGray200,
            borderRadius: theme.spacing(1),
            border: `solid 1px ${theme.palette.iisightGray200}`,
        },
    };
});
/**
 * Component that renders email invite options.
 *
 * @returns {ReactNode}
 */
function EmbedMeetingSection({ url }) {
    const { classes } = useStyles();
    const { t } = useTranslation();
    const embedCode = `<iframe allow="camera; microphone; fullscreen; display-capture; autoplay; clipboard-write; picture-in-picture; document-picture-in-picture" src="${url}"` +
        ' style="height: 100%; width: 100%; border: 0px;"></iframe>';
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.container },
            React.createElement("p", { className: classes.label }, t('addPeople.embedMeeting')),
            React.createElement("div", { className: classes.textAreaContainer },
                React.createElement("p", { className: classes.embedMeetingText }, embedCode),
                React.createElement(CopyButton, { id: 'add-people-copy-embeded-meeting-button', accessibilityText: t('addPeople.accessibilityLabel.meetingLink', {
                        url: getDecodedURI(url),
                    }), className: classes.copyButton, displayedText: t('dialog.copy'), textOnCopySuccess: t('addPeople.codeCopied'), textOnHover: t('dialog.copy'), 
                    // textOnHover={t('addPeople.copyLink')}
                    textToCopy: embedCode })))));
}
export default EmbedMeetingSection;
